module.exports = __webpack_public_path__ + "img/02-2业务痛点.a2a9bb10.svg";